import React, { Component } from 'react';
import PropTypes from 'prop-types';

import UserRoomsListItem from './UserRoomsListItem';

// eslint-disable-next-line react/prefer-stateless-function
class UserRoomsList extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.itemsIds.map(itemId => (
          <UserRoomsListItem
            key={`specialPagesListItem-${itemId}`}
            item={this.props.selectItemById(itemId)}
            auntUserId={this.props.auntUserId}
          />
        ))}
      </React.Fragment>
    );
  }
}

UserRoomsList.propTypes = {
  auntUserId: PropTypes.number.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired
};

export default UserRoomsList;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/UserRoomsList/UserRoomsList.js